/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const ProfileDropDown = createIcon({
    viewBox: '0 0 8 11',
    displayName: 'ProfileDropDown',
    path: (
        <path d="M1.33301 3.4987L3.99967 0.832031L6.66634 3.4987M6.66634 7.4987L3.99967 10.1654L1.33301 7.4987" stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" fill="transparent" />
    ),
})

export default ProfileDropDown